import { http, onSuccess, onFail } from './http';

export const getLanguages = () =>
    http.get(`/api/cp/language`)
        .then(onSuccess, onFail);

export const addLanguage = (data) =>
    http.post(`/api/cp/language`, data)
        .then(onSuccess, onFail);

export const updateLanguage = (id, data) =>
    http.put(`/api/cp/language/${id}`, data)
        .then(onSuccess, onFail);

export const deleteLanguage = (id) =>
    http.delete(`/api/cp/language/${id}`)
        .then(onSuccess, onFail);